import { formatAttributeGroups } from "shared/format-attributes";
import { groupBy } from "lodash";

export const formatGroups = (definitions) => {
    const addGroupRole = definitions.map((attribute) => {
        const label = attribute.sortGroup.name.includes("Standard") ? "Standard" : "Detailed";

        return {
            ...attribute,
            coderLabel: label,
        };
    });
    const groupByRole = groupBy(addGroupRole, "coderLabel");
    const roleLabels = Object.keys(groupByRole).map((role) => {
        const data = {
            subGroups: groupByRole[role],
            groupLabel: role,
        };

        return formatAttributeGroups(data);
    });

    return roleLabels.reduce((allValues, current) => ({ ...allValues, [current.groupLabel]: current }), {});
};
